import {
  collectionGroup,
  getDocs,
  doc,
  collection,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

import { db } from "../firebase";

// ✅ Fetch all users (pseudo lookup)
const fetchAllUsersAsMap = async () => {
  const snap = await getDocs(collection(db, "users"));
  const map = {};
  snap.forEach((docSnapshot) => {
    const data = docSnapshot.data();
    map[docSnapshot.id] = data.pseudo || "(no pseudo)";
  });
  return map;
};

// ✅ Fetch all purchases and enrich with pseudo
export const fetchAllPurchasesWithPseudo = async () => {
  const userMap = await fetchAllUsersAsMap();
  const snap = await getDocs(collectionGroup(db, "purchaseHistory"));

  return snap.docs.map((docSnapshot) => {
    const data = docSnapshot.data();
    const userId = docSnapshot.ref.path.split("/")[1];
    return {
      id: docSnapshot.id,
      userId,
      pseudo: userMap[userId] || userId,
      ...data,
    };
  });
};

// ✅ Optional: update status logic
export const updatePurchaseStatus = async (userId, purchaseId, status) => {
  const ref = doc(db, `users/${userId}/purchaseHistory/${purchaseId}`);
  await updateDoc(ref, { status });
};

// ✅ Persist queue ordering (drag-and-drop) for pending purchases
// updates: Array<{ userId: string, purchaseId: string, queuePosition: number }>
export const updatePurchaseQueuePositions = async (updates) => {
  if (!Array.isArray(updates) || updates.length === 0) return;

  const batch = writeBatch(db);
  for (const update of updates) {
    if (!update?.userId || !update?.purchaseId) continue;
    const ref = doc(db, `users/${update.userId}/purchaseHistory/${update.purchaseId}`);
    batch.update(ref, { queuePosition: Number(update.queuePosition) });
  }
  await batch.commit();
};
